module.exports = {
  // Thermofisher
  THERMO_GATEWAY_LOCATION: process.env.VUE_APP_THERMO_GATEWAY_LOCATION || 'https://qa4-chat-api.thermofisher.com/api/store/chat',
  TF_API_ELIGIBILITY: process.env.VUE_APP_TF_API_ELIGIBILITY || '/api/v1/session/eligibility',
  TF_API_AGENT_AVAILABILITY: process.env.VUE_APP_TF_API_AGENT_AVAILABILITY || '/api/store/chat/rule-engine/tfAgentAvailabilityUI',
  TF_API_AGENT_AVAILABILITY_V2: process.env.VUE_APP_TF_API_AGENT_AVAILABILITY_V2 || '/api/store/chat/rule-engine/v2/tfAgentAvailabilityUI',
  TF_API_MEDALIA_AVALABILITY: process.env.VUE_APP_API_SESSION_MEDALIA || '/api/store/chat/session/medalia',
  TF_API_USER_DETAILS: process.env.VUE_APP_TF_API_USER_TYPE || '/api/store/user-type',
  TF_API_AMPLISEQ_USER_DETAILS: process.env.VUE_APP_TF_API_AMPLISEQ_USER_DETAILS || '/spring/getUserDetails',
  TF_CONNEX_API_GET_SEARCH_RESULTS: process.env.VUE_APP_TF_CONNEX_API_GET_SEARCH_RESULTS || '/search/service/contactUsTypeahead?',
  THERMO_DOMAIN: process.env.VUE_APP_THERMO_DOMAIN || 'https://qa4-chat-api.thermofisher.com',
  THERMO_ROOT_DOMAIN: process.env.VUE_APP_THERMO_ROOT_DOMAIN || 'https://www.qa4.thermofisher.com',
  // fishersci
  FISHER_GATEWAY_LOCATION: process.env.VUE_APP_FISHER_GATEWAY_LOCATION || 'https://qa4-chat-api.fishersci.com/api/store/chat/fs',
  FS_API_ELIGIBILITY: process.env.VUE_APP_FS_API_ELIGIBILITY || '/api/v1/session/eligibility',
  FS_API_AGENT_AVAILABILITY: process.env.VUE_APP_FS_API_AGENT_AVAILABILITY || 'api/store/chat/rule-engine/chat/availability',
  FISHER_DOMAIN: process.env.VUE_APP_FISHER_DOMAIN || 'https://qa4-chat-api.fishersci.com',
  FS_API_MEDALIA_AVALABILITY: process.env.VUE_APP_API_SESSION_MEDALIA || '/api/store/chat/session/medalia',

  start_suggestions: [], // <- array of suggestions, displayed at the start screen
  fallback_lang: 'en', // <- fallback language code, if history mode or network is unavailable
  voice: 'native', // <- voice of Text-To-Speech; for reference, see: https://developer.mozilla.org/en-US/docs/Web/API/SpeechSynthesisVoice/voiceURI
  codecs: { // <- tells browser the mime types of audio in Dialogflow
    OUTPUT_AUDIO_ENCODING_UNSPECIFIED: 'audio/wav',
    OUTPUT_AUDIO_ENCODING_LINEAR_16: 'audio/wav',
    OUTPUT_AUDIO_ENCODING_MP3: 'audio/mpeg',
    OUTPUT_AUDIO_ENCODING_OGG_OPUS: 'audio/ogg'
  },

  enableEmoji: true,
  emojiLocationSet: {
    us: ['👍', '😊', '😔'],
    default: ['👍', '😊', '😔']
  }
}
